import { createSlice } from '@reduxjs/toolkit';

// ---------------------------------------------------------------------------
// authentication slice
// ---------------------------------------------------------------------------
const authenticationSlice = createSlice({
  name: 'authentication',
  initialState: {},
  reducers: {
    setUser(state, action) {
      const payload = action.payload ?? {};
      return {
        user: payload,
        status: payload && payload.osuid ? 'success' : state.status,
      };
    },
    setUserStatus(state, action) {
      return {
        ...state,
        status: action.payload,
      };
    },
  },
});

export const { setUser, setUserStatus } = authenticationSlice.actions;
export const authentication = authenticationSlice.reducer;
